import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Alert, AlertDescription } from '../ui/alert';
import { Loader2, AlertCircle, CheckCircle } from 'lucide-react';
import { userService } from "../../_services";

function GoProConfirmation({ open, onClose, openGoProModal, logout }) {
    const [errors, setErrors] = useState('');
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleClose = () => {
        onClose();
        if (!success && openGoProModal) {
            openGoProModal();
        }
    };

    const handleLogout = () => {
        onClose();
        if (logout) {
            logout();
        }
    };

    const handleGoPro = async () => {
        setLoader(true);
        setErrors('');
        
        try {
            const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
            const [UserId, UserName] = Usermeta_Data.split(':');
            
            // PRESERVE EXACT API CALL - DO NOT CHANGE
            const apidata = await userService.ConsumerToDistributor(UserId, UserName);
            
            if (apidata[0].code == "1" && apidata[0].message == "Success") {
                setSuccess(true);
                setErrors('Your account updated successfully');
                setLoader(false);
                
                setTimeout(() => {
                    handleLogout();
                }, 1500);
            } else {
                setErrors(apidata[0].message);
                setLoader(false);
            }
        } catch (error) {
            console.error('Error upgrading to Pro:', error);
            setErrors('An error occurred. Please try again.');
            setLoader(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={handleClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Go Pro Confirmation</DialogTitle>
                    <DialogDescription>
                        This will upgrade your account to Pro membership
                    </DialogDescription>
                </DialogHeader>

                <div className="space-y-4">
                    <Alert>
                        <AlertCircle className="h-4 w-4" />
                        <AlertDescription>
                            By clicking Yes your account will be upgraded. Please note you will be logged out 
                            and need to login again to your upgraded account!
                        </AlertDescription>
                    </Alert>

                    {errors && (
                        <Alert variant={success ? 'default' : 'destructive'}>
                            {success ? (
                                <CheckCircle className="h-4 w-4" />
                            ) : (
                                <AlertCircle className="h-4 w-4" />
                            )}
                            <AlertDescription>{errors}</AlertDescription>
                        </Alert>
                    )}
                </div>

                <DialogFooter className="gap-2">
                    <Button
                        variant="outline"
                        onClick={handleClose}
                        disabled={loader || success}
                    >
                        No
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={handleGoPro}
                        disabled={loader || success}
                    >
                        {loader ? (
                            <><Loader2 className="h-4 w-4 animate-spin mr-2" />Processing...</>
                        ) : (
                            'Yes'
                        )}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default GoProConfirmation;
